// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__19a2N","actions":"GroupTable_actions__myhQT","deleteModalFooter":"GroupTable_deleteModalFooter__3-A9d"};